import { render } from "./UpcomingEvents.vue?vue&type=template&id=d8ae61b8&scoped=true"
import script from "./UpcomingEvents.vue?vue&type=script&lang=js"
export * from "./UpcomingEvents.vue?vue&type=script&lang=js"

import "./UpcomingEvents.vue?vue&type=style&index=0&id=d8ae61b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8ae61b8"]])

export default __exports__